export default __webpack_public_path__ + "MJt_ass.html";